import { el, setAttr } from 'redom';

import OutsideClickEventRegistration from 'lib/outside-click-event-registration';
import ElementPlacer from 'lib/element-placer';

import { getOperatorsByField } from './utilities';

import NavigableList from 'generics/components/navigable-list/native';

import operators from './operators';

class OperatorSelector {

  constructor(configuration) {

    this.outsideEventRegistration = null;
    this.elementPlacer = null;
    this.operator = null;
    this.field = null;
    this.value = null;
    this.onSelect = null;
    this.onClose = null;
    this.scrollAnchorElement = null;
    this.visible = false;
    this.operator = null;
    this.scrollableParentId = configuration.scrollableParentId;

    this.operatorsList = null;

    this.initializeOperatorsList();

    this.el = el('#operator-selector-main', [this.operatorsList]);

  }

  onmount() {

    this.registerOutsideEventHandler();

  }

  onunmount() {

    this.unregisterOutsideEventHandler();

  }

  initializeOperatorsList() {

    const options = {
      entries: operators,
      selectedEntries: [],
      onSelect: this.handleValueSelect.bind(this),
      onClose: this.handleListClose.bind(this),
      scrollAnchorElement: this.input
    };

    this.operatorsList = new NavigableList(options);

  }

  handleValueSelect([value]) {

    this.value = value;

    this.onSelect && this.onSelect(value);

  }

  handleListClose() {

    this.onClose();

  }

  setField(field) {

    this.field = field;

    const filteredOperators = getOperatorsByField(field);

    const currentOperator = this.operator;
    let selectedEntry = filteredOperators[0];

    if (currentOperator !== null) {
      selectedEntry = filteredOperators.find(function finder(operator) {
        return operator.key === currentOperator.key;
      });
    }
    this.operatorsList.reset({
      entries: filteredOperators,
      selectedEntries: [selectedEntry]
    });

  }

  initializePlacer() {

    // If I forget to call cancel...
    if (this.elementPlacer !== null) {
      this.elementPlacer.cancel();
    }

    const configuration = {
      element: this.el,
      anchor: this.scrollAnchorElement,
      container: 'viewport',
      scrollableParent: document.getElementById(this.scrollableParentId),
      spacing: {
        top: 5
      }
    };
    this.elementPlacer = new ElementPlacer(configuration);

  }

  setOperator(operator) {

    this.operator = operator;

  }

  reconfigure(options) {

    this.operator = options.operator;
    this.scrollAnchorElement = options.scrollAnchorElement;
    this.onSelect = options.onSelect;
    this.onClose = options.onClose;

    this.setField(options.field);

    setAttr(this.el, {
      style: {
        width: this.scrollAnchorElement.offsetWidth + 'px'
      }
    });

    this.initializePlacer();
  }

  show() {

    this.visible = true;
    setAttr(this.el, { style: { display: 'block' } });
    this.el.classList.add('active');
    this.elementPlacer.placeVertically();

  }

  hide() {

    this.visible = false;
    setAttr(this.el, { style: { display: 'none' } });
    this.el.classList.remove('active');
    this.elementPlacer.cancel();

  }

  outsideClickHandler(clickTargetElement) {

    if (this.visible === false) {
      return;
    }

    if (this.scrollAnchorElement === clickTargetElement || this.scrollAnchorElement.contains(clickTargetElement) === true) {
      return;
    }

    this.onClose();

  }

  registerOutsideEventHandler() {

    this.outsideEventRegistration = new OutsideClickEventRegistration(this.el, this.outsideClickHandler.bind(this));

  }

  unregisterOutsideEventHandler() {

    this.outsideEventRegistration.cancel();

  }

}

export default OperatorSelector;